import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useTheme} from '@mui/material/styles';
import {Button, Dialog} from 'wobi-web-common/dist/v2/index.js';

const MedicalExtendedModal = ({open, onClose, children, onSubmit, submitDisabled, submitLabel}) => {
  const intl = useIntl();
  const theme = useTheme();
  const footer = onSubmit ? (
    <Button variant='accent' size='lg' onClick={onSubmit} disabled={submitDisabled}>
      {submitLabel || intl.formatMessage({id: 'continue'})}
    </Button>
  ) : null;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={intl.formatMessage({id: 'medical.extendedTitle'})}
      titleColor={theme.palette.secondary.main}
      centeredHeader
      centeredFooter
      ariaLabel={intl.formatMessage({id: 'medical.extendedTitle'})}
      width={620}
      footer={footer}
      style={{maxHeight: '90vh', overflowY: 'auto'}}
    >
      {children}
    </Dialog>
  );
};

MedicalExtendedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  submitDisabled: PropTypes.bool,
  submitLabel: PropTypes.node,
};

export default MedicalExtendedModal;
